import React, { PureComponent } from 'react';
import { getFieldsFromDateAsFormat } from '../../utils/dateFormatter.js';
import { getDateRange } from '../utils/getDateRange.js';
import { signInCheck } from '../../components/common/CheckUserStatus';

class EstimatedDeliveryInformation extends PureComponent {
  render() {
    const {
      edd: { activePincode, eddDetails, isEDDFetching },
      selectedSizeCode,
      serviceabilityDetails,
      errorInServiceabilityFetching,
      isCheckServiceabilityCalled,
      returnCodCommunication,
      productServiceAbility
    } = this.props;
    let productSpecificEDDDetails = {};
    if (isEDDFetching) {
      return <div className="edd-loader" />;
    }
    if (activePincode && selectedSizeCode && eddDetails[activePincode]) {
      productSpecificEDDDetails = eddDetails[activePincode][selectedSizeCode];
      if (!productSpecificEDDDetails || Object.keys(productSpecificEDDDetails).length === 0) {
        return null;
      }
    }
    const isSignedIn = signInCheck();
    const {isPdpEnabled: isReturnCommunicationPdpEnabled, codAvailableMsgDesktop, codUnavailableMsgDesktop} = returnCodCommunication;  

    const { cod = {} } = serviceabilityDetails;
    const { codAllowed = false } = cod;
    const { codEligible, servicability, eddUpper, eddLower } = productSpecificEDDDetails || {};
    const { codAllowed: pdpCodAllowed = false } = productServiceAbility;
    const isCodAvailableSignedIn = isSignedIn && isCheckServiceabilityCalled && !errorInServiceabilityFetching 
    let codAvailability = isReturnCommunicationPdpEnabled ? isCodAvailableSignedIn ? codAllowed && codEligible && pdpCodAllowed: codEligible && pdpCodAllowed: codEligible;
    const dateRange = getDateRange({ eddLower, eddUpper, showDateSpecifically: true });
    return (
      <div className="edd-message-success">
        {servicability && (
          <div className="edd-message-success-container">
            <div className="edd-message-success-pincode">{activePincode}</div>
            <ul className="edd-message-success-details">
              <li key={1}>
                Expected Delivery:
                <span className="edd-message-success-details-highlighted">{dateRange}</span>
              </li>
              <li className="font-bold" key={2}>
                {codAvailability ? codAvailableMsgDesktop : codUnavailableMsgDesktop}
              </li>
            </ul>
            <div>
              <span className="edd-message-success-details-note">
                The final delivery date will depend on the items in your bag
              </span>
            </div>
          </div>
        )}
      </div>
    );
  }
}
export default EstimatedDeliveryInformation;
